import { fetchDispatch } from 'data/helpers'
import { showSnackbar, snackbarTypes } from 'src/redux/snackbar'

const TRIGGER_GEOCODING_LOADING = 'backgroundJobLauncher/TRIGGER_GEOCODING_LOADING'
const TRIGGER_GEOCODING_DONE = 'backgroundJobLauncher/TRIGGER_GEOCODING_DONE'
const TRIGGER_EMBEDDINGS_LOADING = 'backgroundJobLauncher/TRIGGER_EMBEDDINGS_LOADING'
const TRIGGER_EMBEDDINGS_DONE = 'backgroundJobLauncher/TRIGGER_EMBEDDINGS_DONE'

export const triggerGeocoding = () => {
  return async dispatch => {
    dispatch({ type: TRIGGER_GEOCODING_LOADING })
    try {
      await fetchDispatch({
        path: '/api/background_jobs/geocoding',
        method: 'POST',
      })
      dispatch(showSnackbar('Geocoding job triggered successfully', snackbarTypes.SUCCESS))
    } catch (error) {
      dispatch(showSnackbar('Failed to trigger geocoding job', snackbarTypes.ERROR))
    } finally {
      dispatch({ type: TRIGGER_GEOCODING_DONE })
    }
  }
}

export const triggerEmbeddings = () => {
  return async dispatch => {
    dispatch({ type: TRIGGER_EMBEDDINGS_LOADING })
    try {
      await fetchDispatch({
        path: '/api/background_jobs/embeddings',
        method: 'POST',
      })
      dispatch(showSnackbar('Embeddings job triggered successfully', snackbarTypes.SUCCESS))
    } catch (error) {
      dispatch(showSnackbar('Failed to trigger embeddings job', snackbarTypes.ERROR))
    } finally {
      dispatch({ type: TRIGGER_EMBEDDINGS_DONE })
    }
  }
}

const initialState = {
  geocodingLoading: false,
  embeddingsLoading: false,
}

export const backgroundJobLauncherReducer = (state = initialState, action) => {
  switch (action.type) {
    case TRIGGER_GEOCODING_LOADING:
      return { ...state, geocodingLoading: true }
    case TRIGGER_GEOCODING_DONE:
      return { ...state, geocodingLoading: false }
    case TRIGGER_EMBEDDINGS_LOADING:
      return { ...state, embeddingsLoading: true }
    case TRIGGER_EMBEDDINGS_DONE:
      return { ...state, embeddingsLoading: false }
    default:
      return state
  }
}
